import type { Priority } from '@/types/activity';

export const PRIORITIES: Priority[] = ['critical', 'high', 'medium', 'low'];

export const PRIORITY_LABELS: Record<Priority, string> = {
  low: 'Baixa',
  medium: 'Média',
  high: 'Alta',
  critical: 'Crítica',
};

/** Badge (cards, tabela). Classes literais — o JIT do Tailwind as encontra sem safelist. */
export const PRIORITY_BADGE: Record<Priority, string> = {
  low: 'bg-slate-100 text-slate-600 border border-slate-200',
  medium: 'bg-sky-100 text-sky-700 border border-sky-200',
  high: 'bg-amber-100 text-amber-800 border border-amber-200',
  critical: 'bg-rose-100 text-rose-700 border border-rose-300',
};

/** Chip do calendário por prioridade. */
export const PRIORITY_CHIP: Record<Priority, string> = {
  low: 'bg-slate-100 text-slate-700 border border-slate-200',
  medium: 'bg-sky-50 text-sky-800 border border-sky-200',
  high: 'bg-amber-50 text-amber-900 border border-amber-300',
  critical: 'bg-rose-100 text-rose-800 border border-rose-300',
};

export const PRIORITY_RANK: Record<Priority, number> = { low: 1, medium: 2, high: 3, critical: 4 };
